import {
  Box,
  Button,
  Container,
  Grid,
  Header,
  SpaceBetween
} from '@cloudscape-design/components';
import { useContext, useEffect, useState } from 'react';
import { filteredViewSentences } from '../../helpers/filteredView';
import { DocumentContext } from '../../context/documentContext';
import { createFile } from '../../helpers/createDocx';
import { getOwnership } from '../../helpers/getOwnership';
import { getReportTitle } from '../../helpers/getReportType';
import { config, report } from 'process';
import { sentenceItem } from '../../models/interfaces';
import {
  getAllConstructionSentences,
  getDomainExpectations,
  getDomainObligations
} from '../../helpers/getOverViews';
import { all } from 'axios';

export const ReportsView = () => {
  const { sentences, currentDoc } = useContext(DocumentContext);
  const [reportObject, setReportObject] = useState<{
    [key: string]: sentenceItem[];
  }>({});

  const createSpecificReport = (reportType: string) => {
    let reportTypeToUse = reportType;
    console.log('creating report', reportType);
    if (reportType === 'all') {
      createFile(currentDoc.documentFileName, sentences, 'Redline Report');
      return;
    }
    if (reportType === 'ownership') {
      const ownerList = getOwnership(sentences);
      reportTypeToUse = `ownership@${ownerList.join(':::')}`;
    }
    if (reportType !== 'construction') {
      const filteredSentences = filteredViewSentences(
        reportTypeToUse,
        sentences
      );
      const reportTitle = getReportTitle(reportTypeToUse);
      if (filteredSentences.sentences.length > 0) {
        createFile(
          currentDoc.documentFileName,
          filteredSentences.sentences,
          reportTitle
        );
      }
    }
    if (reportType === 'construction') {
      const oblicgtionsAndEcpectations = getAllConstructionSentences(sentences);
      if (oblicgtionsAndEcpectations.length > 0) {
        createFile(
          currentDoc.documentFileName,
          oblicgtionsAndEcpectations,
          'Obligations and Expectations'
        );
      }
    }
  };

  const createReportMap = () => {
    const types = [
      'general-obligation',
      'service',
      'dates',
      'financial',
      'places',
      'people'
    ];
    const reportMap: { [key: string]: sentenceItem[] } = {};
    for (const type of types) {
      const result = filteredViewSentences(type, sentences);
      if (result.sentences.length > 0) {
        reportMap[type] = result.sentences;
      }
    }
    console.log('report obj', reportMap);
    const getOwners = getOwnership(sentences);
    if (getOwners.length > 0) {
      reportMap['ownership'] = [];
    }
    const allConstrunction = getAllConstructionSentences(sentences);
    if (allConstrunction.length > 0) {
      reportMap['construction'] = allConstrunction;
    }
    setReportObject(reportMap);
  };

  useEffect(() => {
    createReportMap();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sentences]);
  return (
    <Container
      header={
        <Header>
          <SpaceBetween direction="vertical" size="xxs">
            <h1>Reports</h1>
            <h6 style={{ margin: '0 0' }}>Print reports.</h6>
          </SpaceBetween>
        </Header>
      }
    >
      <SpaceBetween direction="vertical" size="s">
        <Box textAlign="center">
          <Button onClick={() => createSpecificReport('all')}>
            Full Report
          </Button>
        </Box>
        <Grid
          gridDefinition={[
            { colspan: { default: 4, m: 4 } },
            { colspan: { default: 4, m: 4 } },
            { colspan: { default: 4, m: 4 } }
          ]}
        >
          <Container
            fitHeight
            header={<Header>Obligations & Expectations</Header>}
          >
            <SpaceBetween size={'xl'} alignItems="center">
              <Button
                disabled={!reportObject['construction']}
                onClick={() => createSpecificReport('construction')}
              >
                Construction Obligations
              </Button>
            </SpaceBetween>
          </Container>
          <Container fitHeight header={<Header>Negotiation Areas</Header>}>
            <SpaceBetween size={'xl'} alignItems="center">
              <Button
                disabled={!reportObject['service']}
                onClick={() => createSpecificReport('service')}
              >
                Service level requirements
              </Button>
              <Button
                disabled={!reportObject['dates']}
                onClick={() => createSpecificReport('dates')}
              >
                Obligations due dates
              </Button>
              <Button
                disabled={!reportObject['ownership']}
                onClick={() => {
                  createSpecificReport('ownership');
                }}
              >
                Burden Assignment
              </Button>
            </SpaceBetween>
          </Container>
          <Container fitHeight header={<Header>Important Information</Header>}>
            <SpaceBetween size={'xl'} alignItems="center">
              <Button
                disabled={!reportObject['financial']}
                onClick={() => createSpecificReport('financial')}
              >
                Financial Information
              </Button>
              <Button
                disabled={!reportObject['people']}
                onClick={() => createSpecificReport('people')}
              >
                People, Roles & Responsibilities
              </Button>
              <Button
                disabled={!reportObject['places']}
                onClick={() => createSpecificReport('places')}
              >
                Places and Locations
              </Button>
            </SpaceBetween>
          </Container>
        </Grid>
      </SpaceBetween>
    </Container>
  );
};
